<div class="menu-wrapper" [class.expanded]="state.expanded()" [class.collapsed]="!state.expanded()">
  <div class="header">
    <!-- <svg style="cursor: pointer" (click)="state.expanded.set(true)" xmlns="http://www.w3.org/2000/svg" width="40" height="35" viewBox="0 0 40 35" fill="none">
      <path d="M0.722656 0.921875L19.9992 34.6617L39.2757 0.921875H0.722656ZM15.5168 9.55006H24.4815L19.9992 17.3969L15.5168 9.55006Z" fill="url(#paint0_linear_5632_69434)"/>
      <defs>
        <linearGradient id="paint0_linear_5632_69434" x1="15.5085" y1="-6.94178" x2="33.7138" y2="24.2679" gradientUnits="userSpaceOnUse">
          <stop stop-color="#62D4FF"/>
          <stop offset="1" stop-color="#1482FF"/>
        </linearGradient>
      </defs>
    </svg> -->
    <img src="TebiTaskIcon.png" style="width: 32px; aspect-ratio: 1; cursor: pointer;" (click)="state.expanded.set(!state.expanded())">
    @if (state.expanded()) {
      <p class="app-title">
        TebiTask
      </p>
      <button class="icon-button" (click)="state.expanded.set(false)"><mat-icon>menu_open</mat-icon></button>
    } @else {
      <div class="relative-anchor">
        <button class="icon-button absolute" (click)="state.expanded.set(true)"><mat-icon>keyboard_arrow_right</mat-icon></button>
      </div>
    }
  </div>

  <mat-nav-list class="menu-item-list">

    <button disabled class="nav-item" [class.selected]="selected() == 'dashboard'"> <!-- routerLink="/dashboard" -->
      <mat-icon matListItemIcon>dashboard</mat-icon>
      @if (state.expanded()) {
        <div>{{ ('common:overview' | translate)() }}</div>
      }
    </button>
    <button class="nav-item" routerLink="/okr" [class.selected]="selected() == 'okr'" id="goalsNavButton">
      <mat-icon matListItemIcon>flag</mat-icon>
      @if (state.expanded()) {
        <div>{{ ('common:goals' | translate)() }}</div>
      }
    </button>
    <button disabled class="nav-item" [class.selected]="selected() == 'tasks'"> <!-- routerLink="/tasks" -->
      <mat-icon matListItemIcon>check_circle</mat-icon>
      @if (state.expanded()) {
        <div>{{ ('common:tasks' | translate)() }}</div>
      }
    </button>
    <button disabled class="nav-item" [class.selected]="selected() == 'documents'"> <!-- routerLink="/documents" WA-1349: disabled until access control is implemented -->
      <mat-icon matListItemIcon>content_copy</mat-icon>
      @if (state.expanded()) {
        <div>{{ ('common:documents' | translate)() }}</div>
      }
    </button>

    <p style="flex-grow: 1;"></p>

    <button id="mainMenuHelpButton" class="profile-button" (click)="openHelpDialog()">
      <mat-icon matListItemIcon>help</mat-icon>
      @if (state.expanded()) {
        <div>{{ ('help' | translate)() }}</div>
      }
    </button>

    <button class="profile-button" [mat-menu-trigger-for]="profileMenu">

      <!-- <img class="profile-picture" [src]="authService.picture()" [alt]="authService.email()"> -->
      <tebitasks-initials-display [givenName]="authService.givenName()" [familyName]="authService.familyName()" />

      @if (state.expanded()) {
        <div class="username">{{ authService.givenName() }} {{ authService.familyName() }}</div>
      }
      <mat-icon>chevron_right</mat-icon>
    </button>
    <mat-menu #profileMenu class="white-background">
      <button mat-menu-item [matMenuTriggerFor]="languageMenu">Language</button>
      <button mat-menu-item (click)="logout()">{{('logout' | translate)()}}</button>

      <mat-menu #languageMenu class="white-background">
        <button mat-menu-item (click)="setLang('de')">Deutsch</button>
        <button mat-menu-item (click)="setLang('en')">English</button>
      </mat-menu>
    </mat-menu>

    <div class="nav-list">
      <p class="version-info">{{ versionInfo() }}</p>
      <p class="version-info">{{ cloudComponentsVersionInfo() }}</p>
      <p class="version-info">{{ backendVersionInfo() }}</p>
    </div>

  </mat-nav-list>
</div>
